import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import { I18n } from "@aws-amplify/core";

import { roles } from "../../constants/roles";
import DropdownDown from './assets/dropdown_arrow_down.svg';
import DropdownRight from './assets/dropdown_arrow_right.svg';

const styles = {
  mobileMain: {
    backgroundColor: "white",
  },
  mobileRequests: {
    padding: "0 8px",
    boxSizing: "border-box",
    width: "100%",
  },
  mobileRow: {
    padding: "8px 8px",
    borderBottom: "1px solid #dddddd",
    color: "hsla(0, 0%, 0%, 0.54)",
    boxSizing: "border-box",
  },
  mobileRowHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerControl: {
    display: "flex",
    alignItems: "center",
  },
  mobileOrderId: {
    paddingLeft: "4px",
    color: "hsla(0, 0%, 0%, 0.87)",

  },
  mobileQty: {
    textAlign: "right",
  },
  blueText: {
    color: "#5f00a0",
    cursor: "pointer",
  },
  orderHighlight: {
    fontWeight: "500",
  },
  systemMessage: {
    width: "270px",
  },
  smallText: {
    fontSize: "12px",
    wordWrap: "break-word",
  },
  productError: {
    backgroundColor: "#fdeceb",
  },
};

const generateDate = date => {
  const localDate = new Date(date + " UTC")
  return localDate.toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, minute: '2-digit' })//.replace(/,/g, "")
}


const MobileOrderRow = (props) => {
  const { classes, language } = props;

  const [isOpen, setIsOpen] = React.useState(false)
  const level = get(props, ["userRole", "level"]);

  React.useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`${classes.mobileRow} ${props.order.system_message && level <= roles.customerAdmin ? classes.productError : ""}`} >
      <div className={classes.mobileRowHeader}>
        <div className={classes.headerControl}>
          <img src={isOpen ? DropdownDown : DropdownRight} onClick={() => setIsOpen(!isOpen)} alt="Dropdown" />
          <div className={classes.mobileOrderId} onClick={() => setIsOpen(!isOpen)}><span className={classes.orderHighlight}>#{props.order.order_id}</span> - {language === 'en' ? props.order.order_status_en : props.order.order_status_fr}</div>
        </div>
        <div className={`${classes.mobileQty} ${classes.blueText}`} onClick={() => props.handleOrderInfo(props.order)}>{`${props.order.product_quantity} ${props.order.product_quantity > 1 ? I18n.get("site_products") : I18n.get("site_product")}`}</div>
      </div>
      <div>{generateDate(props.order.created_on)}</div>
      {isOpen ?
        <>
          <div>{props.order.VMI}</div>
          {props.order.order_customer_order_id ? <div>{props.order.order_customer_order_id}</div> : null}
          <div>{I18n.get("events_createdBy")}: {props.order.created_by}</div>
          {props.order.system_message ? <div className={`${classes.systemMessage} ${classes.smallText}`}>{props.order.system_message}</div> : null}
        </>
        : null
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    user: state.user,
    userRole: get(state, ["user", "role"]),
    solutionsAccess: get(state, ["user", "solutionsAccess"]),
    permissions: get(state, ["user", "permissions"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(MobileOrderRow))

);